import type { CursorPaged } from '@/infra/paging'
import type { FreshbooksCallCenterApi } from '@/features/freshbooks/api/freshbooks-api'
import type { CallCenterContact } from '@/features/freshbooks/CallCenterContact'
import { mapCallCenterContactResourceToCallCenterContact } from '@/features/freshbooks/call-center-contact-mappers'

/**
 * Query for {@link CallCenterContactStore.searchCallCenterContacts}.
 */
export interface SearchCallCenterContactsQuery {
  search?: string
  signedUpForWaitlist?: boolean
  limit?: number
  after?: string
}

/**
 * Searches the call center's HubSpot contacts through Freshbooks.
 */
export class CallCenterContactStore {
  constructor(private readonly _api: FreshbooksCallCenterApi) {}

  /**
   * Searches contacts.
   */
  async searchCallCenterContacts(
    {
      search,
      signedUpForWaitlist,
      limit,
      after,
    }: SearchCallCenterContactsQuery,
    signal?: AbortSignal,
  ): Promise<CursorPaged<CallCenterContact>> {
    const response = await this._api.searchContacts(
      {
        search,
        signed_up_for_waitlist: signedUpForWaitlist,
        limit,
        after,
      },
      signal,
    )

    return {
      data: response.data.map(mapCallCenterContactResourceToCallCenterContact),
      next: response.cursor || null,
    }
  }
}
